import React, { useReducer, createContext } from "react";
import { gameReducer, gameInitialState } from "../reducers";
import constant from "../constants/gameConstant";
import { gameService } from "../services";
import { toast } from "react-toastify"
import { history } from "../tools";

export const GameContext = createContext();

export const GameContextProvider = (props) => {

    const [state, dispatch] = useReducer(gameReducer, gameInitialState);

    const get = (id, isRequest = true) => {

        if (isRequest) {

            dispatch(request());
        }

        gameService.get(id).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));
            }).
            catch(ex => {

                toast.error("the game couldn't be fetched!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.GET_SUCCESS, payload: data }; }
        function fail() { return { type: constant.GET_FAIL }; }
        function request() { return { type: constant.GET_REQUEST }; }
    };

    const add = (game, onSuccess) => {

        dispatch(request());

        gameService.add(game).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));

                if (onSuccess) {

                    onSuccess(response.data);
                }
            }).
            catch(ex => {

                toast.error("the game couldn't be added!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.ADD_SUCCESS, payload: data }; }
        function fail() { return { type: constant.ADD_FAIL }; }
        function request() { return { type: constant.ADD_REQUEST }; }
    };

    const should = (dto, onSuccess) => {

        dispatch(request());

        gameService.should(dto).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));

                if (onSuccess) {

                    onSuccess();
                }
            }).
            catch(ex => {

                toast.error("the game couldn't be rated!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.SHOULD_SUCCESS, payload: data }; }
        function fail() { return { type: constant.SHOULD_FAIL }; }
        function request() { return { type: constant.SHOULD_REQUEST }; }
    };

    const addPlayList = (dto, onSuccess) => {

        dispatch(request());

        gameService.addPlayList(dto).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));

                if (onSuccess) {

                    onSuccess();
                }
            }).
            catch(ex => {

                toast.error("The game couldn't be added to your playing list!");

                dispatch(fail("!"));
            });

        function request() { return { type: constant.ADD_LIST_REQUEST }; }
        function success(data) {
            return { type: constant.ADD_LIST_SUCCESS, payload: data };
        }
        function fail() { return { type: constant.ADD_LIST_FAIL }; }
    };

    const getPlatforms = () => {

        dispatch(request());

        gameService.getPlatforms().
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));
            }).
            catch(ex => {

                toast.error("platforms couldn't be fetched!");

                dispatch(fail("!"));
            });

        function success(data) {
            return { type: constant.GET_PLATFORMS_SUCCESS, payload: data };
        }
        function fail() { return { type: constant.GET_PLATFORMS_FAIL }; }
        function request() { return { type: constant.GET_PLATFORMS_REQUEST }; }
    };

    const search = (key) => {

        dispatch(request());

        gameService.search(key).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));
            }).
            catch(ex => {

                toast.error("games couldn't be fetched!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.SEARCH_SUCCESS, payload: data }; }
        function fail() { return { type: constant.SEARCH_FAIL }; }
        function request() { return { type: constant.SEARCH_REQUEST }; }
    };

    const goToDetail = (id) =>{

        history.push("/game/" + id)
    }

    const reset = () => {

        dispatch({ type: constant.RESET })
    }

    const paginate = (dto, onSuccess) => {

        dto = { ...{ limit: 12 }, ...dto };

        dispatch(request());

        gameService.paginate(dto).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));

                if (onSuccess) {

                    onSuccess();
                }
            }).
            catch(ex => {

                toast.error("games couldn't be fetched!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.PAGINATE_SUCCESS, payload: data }; }
        function fail() { return { type: constant.PAGINATE_FAIL }; }
        function request() { return { type: constant.PAGINATE_REQUEST }; }
    };

    return (
        <GameContext.Provider value={[state,
            {
                add,
                search,
                paginate,
                getPlatforms,
                get,
                should,
                reset,
                addPlayList,
                goToDetail
            }]}>
            {props.children}
        </GameContext.Provider>
    );
};

